import React, { useEffect } from "react";
import Slider from "react-slick";
import { getCategories } from "./category-section.service";
import { Link } from "react-router-dom";

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 4,
  slidesToScroll: 1,
  rows: 2,
  autoplay: true,
  autoplaySpeed: 1500,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

interface Category {
  id: number;
  image: any;
  name: string;
  link: string;
}

const CategoryCard: React.FC<Category> = ({ image, name, link, id }) => (
  <div className="ec_cat_content">
    <div className="ec_cat_inner">
      <div
        className="ec-cat-image"
        style={{ height: "300px", overflow: "hidden" }}
      >
        {image ? (
          <img
            src={`https://d1gdand68muq63.cloudfront.net/categories/sm/${image.key}`}
            alt={name}
            style={{ height: "100%", width: "100%", objectFit: "cover" }}
          />
        ) : (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f0f0f0",
            }}
          >
            No Image Available
          </div>
        )}
      </div>
      <div className="ec-cat-desc">
        <span className="ec-section-btn">
          <Link to={`/products?category=${id}`} className="btn-primary">
            {name}
          </Link>
        </span>
      </div>
    </div>
  </div>
);

export default function CategorySection() {
  const [categories, setCategories] = React.useState<Category[]>([]);

  useEffect(() => {
    getCategories().then((response: any) => {
      const categories = response.data;
      setCategories([
        ...categories,
        ...categories,
        ...categories,
        ...categories,
      ]);
    });
  }, []);

  if (categories.length === 0) {
    return null;
  }

  return (
    <section className="section ec-category-section section-space-p">
      <div className="container">
        <div className="row">
          <div className="col-md-12 section-title-block">
            <div className="section-title">
              <h2 className="ec-title">Browse By Categories</h2>
              <p className="sub-title">Check out our feature products.</p>
            </div>
            <div className="section-btn">
              <span className="ec-section-btn">
                <Link className="btn-primary" to="products">
                  View All Categories
                </Link>
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <Slider className="ec_cat_slider" {...sliderSettings}>
            {categories.map((category, index) => (
              <CategoryCard key={index} {...category} />
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
